import {Injectable} from '@angular/core';
import {HrTool} from '@frontend/directus';
import {ProjectCoverageDataResponse} from '@frontend/shared-api';
import {weightedCoverage} from './rfi-weighted-coverage.calc';
import {RfiCoverage} from './step-5-3-rfi-invitation-list.types';

@Injectable({
  providedIn: 'root',
})
export class RfiCoverageCalculationService {
  calculateDetailedCoverage(
    customerData: ProjectCoverageDataResponse,
    hrTool: HrTool,
  ): RfiCoverage {
    const details = weightedCoverage(
      customerData.requirements,
      hrTool.moduleFunctions.map((moduleFunction) => moduleFunction.id),
      hrTool.availableCountries.map((country) => country.isoCode),
    );

    return {
      totalCoverage: details.score,
      coveredFunctionCount: details.coveredFunctionIds.length,
      coveredCountryCount: details.supportedCountryIsoCodes.length,
      hasGaps: details.gaps.length > 0,
      details,
    };
  }
}
